import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export const CHECKOUT_URL = 'https://drum-ready.impultienda.ar/checkout';
const TRACKING_KEY = 'dr_landing_query';
// Keeps fbclid / utm_* from the landing URL and passes them to the checkout.
function withTracking(href: string): string {
  if (typeof window === 'undefined' || href.startsWith('#')) return href;
  let query = window.location.search;
  try {
    if (query && query.length > 1) {
      window.sessionStorage.setItem(TRACKING_KEY, query);
    } else {
      query = window.sessionStorage.getItem(TRACKING_KEY) || '';
    }
  } catch {
    // sessionStorage may be blocked; fall back to the current query only.
  }
  if (!query || query.length < 2) return href;
  const params = query.replace(/^\?/, '');
  return href + (href.includes('?') ? '&' : '?') + params;
}
type CtaButtonProps = {
  label?: string;
  href?: string;
  className?: string;
};
export function CtaButton({
  label = 'Get DRUM READY™ now',
  href = CHECKOUT_URL,
  className = ''
}: CtaButtonProps) {
  const isInternal = href.startsWith('#');
  const finalHref = isInternal ? href : withTracking(href);
  return <a href={finalHref} target={isInternal ? undefined : '_blank'} rel={isInternal ? undefined : 'noopener noreferrer'} className={`group inline-flex items-center justify-center gap-2.5 whitespace-nowrap rounded-full bg-red-700 px-5 py-4 text-center text-sm font-semibold text-white shadow-lg shadow-red-700/30 transition-[transform,background-color] duration-150 ease-out hover:bg-red-800 active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-red-700/30 sm:px-9 sm:py-5 sm:text-base ${className}`} data-id="element-66" data-mp="39z18hdb7glui">
      <span data-id="element-67" data-mp="1lah7ga7czh4">{label}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-68" data-mp="6ikbpacg81bt" />
    </a>;
}